import About from 'components/services/commons/About'
import Whyi3 from 'components/services/commons/Whyi3'
import styles from 'components/services/feature-engineering/Template.module.scss'
import Process from 'components/services/commons/Process'
import ServiceMainTitle from 'components/services/commons/ServiceMainTitle'
import { serviceMainTitle } from './TitleGroup'
import CaseStudy from '../../home/CaseStudy/CaseStudy'
import MeetBellona from './components'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'
import InHouseSupport from '../commons/InHouseSupport/InHouseSupport'

const FeatureEngineering: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Services', url: '#' },
    { name: '特徴量エンジニアリングと生成AI', url: '#' },
  ]
  const aboutList = [
    {
      text: '生成AIで十分なアウトプットが得られないと試行錯誤している企業に、当社の特徴量エンジアリングを活用したノウハウならびにPoCを実施します。',
    },
    {
      text: '最新のトランスフォーマーベースモデル（GPTと同様）を活用し、顧客固有のデータからゼロベースで学習させた独自のアプローチを提供しています。このアプローチには様々な利点があります。',
    },
    {
      text: 'まず、AI専門家チームによるビジネス領域の分析を行い、AIソリューションが顧客のビジネスニーズに最適化されます。長年の実績に基づき、機能しないAI製品を提供するリスクを大幅に削減します。ビジネスニーズに基づいたAIソリューションを導入することで、最先端技術を活用し、競合他社に先駆けて市場をリードすることが可能になります。さらに、最新のAIテクノロジーを顧客に提供することで、革新的なサービスや製品の実現を支援します。',
    },
  ]

  const processList = [
    {
      title: 'ビジネス領域の分析',
      text: '始めに、お客さまのビジネス領域における既存データと潜在的可能性を分析します。この段階では、お客さまのローデータ、ビルダー、フレームワーク、ブランドブック、またはデザインシステムへの限定的なアクセスが必要となります。当社の専門家がこの分析を通じて、AIアプローチがお客さまの特定のビジネス状況に有益かどうかを判断いたします。',
    },
    {
      title: 'ビジネス提案',
      text: '分析段階を踏まえ、包括的なビジネス提案を作成します。この提案には、必要になる開発やテストの見積もり、潜在的な利益、そしてUI/UXのモックアップが含まれます。',
    },
    {
      title: '開発/運用フェーズ',
      text: 'AIモデルの開発と実装は、本番環境での使用準備が整うまで反復的なプロセスで行います。新機能を段階的に追加できるよう、このプロセスは分割で行うことも可能です。運用段階では、AIモデルの精度を監視し、成長を見据えた再学習モデルを構築します。',
      content: [
        {
          title: 'ローデータの準備',
          text: 'モデル訓練用のデータセット作成に使用するローデータを準備します。準備内容にはローデータの選択とフィルタリング、そしてストレージの構築が含まれます。データ分析に適した状態にし、将来の反復使用のためのデータセット作成を迅速化する自動化も導入します。',
        },
        {
          title: '特徴量エンジニアリング',
          text: '特徴量エンジニアリングはアプローチにおいて重要な要素になります。この段階で、モデル訓練に最適なデータの記述と構造化方法を慎重に分析・定義します。オーダーメイドのスーツを仕立てるように、お客さまのビジネスニーズに合わせて特徴量をカスタマイズします。',
        },
        {
          title: '訓練とテスト',
          text: 'モデルの訓練を行うたびに、出力が要件を満たしていることを確認します。',
        },
        {
          title: 'レビューと分析',
          text: '最新の訓練済みモデルの出力をUI/UXと統合し、徹底的にテストを行います。結果が必要な基準を満たしていれば、そのモデルは本番環境での使用準備が整ったことになります。基準を満たさない場合は、望ましい品質に達するまで反復プロセスを繰り返します。',
        },
        {
          title: '本番環境へのデプロイ',
          text: '新しいAI機能をお客さまの本番環境にデプロイします。品質を保証するために必要な自動化と追加テストを提供いたします。',
        },
      ],
    },
  ]

  const reasonList = [
    {
      icon: '/images/icons/feature_engineering_features_icon_1.svg',
      title: '制御された学習プロセス',
      text: '一般的なLLM（大規模言語モデル）ベースのAIと比較して、より高度なモデルの学習過程と出力に対する制御を実現しています。強化された制御により、AIハルシネーション（AIの誤った生成）の可能性を低減し、より正確で信頼性の高い結果を提供することが可能になりました。',
    },
    {
      icon: '/images/icons/feature_engineering_features_icon_2.svg',
      title: '満足度の高いAIユーザビリティ',
      text: '生成プロセス中にAIが提案する次の要素をリアルタイムで調整する機能により、ユーザビリティが大幅に向上しています。特定の要素の再生成を指示することができ、クライアントのニーズに合わせて出力をカスタマイズすることが可能です。',
    },
    {
      icon: '/images/icons/feature_engineering_features_icon_3.svg',
      title: '関連性ブースター',
      text: '関連性ブースターと呼ばれる独自のAI機能により、ユーザーとの対話を通じてより迅速で関連性の高い提案が可能になりました。',
    },
    {
      icon: '/images/icons/feature_engineering_features_icon_4.svg',
      title: 'インタラクティブな提案モード',
      text: 'AIモデルに搭載されている「提案モード」は、デザインプロセス中にリアルタイムで複数の関連デザイン要素やアイデアを提示します。AIとインタラクティブな対話を通じることにより、デザインプロセスがより効率的になり、ユーザー体験が向上します。',
    },
    {
      icon: '/images/icons/feature_engineering_features_icon_5.svg',
      title: '柔軟なエクスポートオプション',
      text: '構造化されたAI出力により、FigmaやWebflowなどの一般的なデザインツール、さらにはReactやFlutter codeなどのコードフレームワークへのエクスポートが簡単に行えます。これにより、デザインからプロトタイプ、実装までのワークフローがシームレスになります。',
    },
    {
      icon: '/images/icons/feature_engineering_features_icon_6.svg',
      title: '高いパフォーマンス',
      text: 'このAIモデルは一般的なLLM（大規模言語モデル）と比較して、高いパフォーマンスを発揮しつつ、必要なリソースを大幅に削減しています。',
    },
  ]

  const MeetBellonaList = {
    content: [
      { text: ['独自のユーザーインタラクション、提案モードと段階的な生成'] },
      { text: ['ゼロからのトレーニング', 'UIを記述するためのカスタム設計言語'] },
      { text: ['高度な特徴量エンジニアリング', 'デザインルール、配置、スタイルの組み込み'] },
      { text: ['1000以上の商品詳細ページから作成したデータセット'] },
      { text: ['GPTと同様のトランスフォーマーベースモデル'] },
      { text: ['700万パラメータと、3000語以上のボキャブラリー'] },
      { text: ['一般的なLLMと比較して15倍少ないメモリを使用'] },
      { text: ['一般的なLLMと比較してCPU上で20倍のパフォーマンス'] },
      { text: ['簡単に編集できるよう最適化されたFigmaへのエクスポート'] },
    ],
    img: [{ src: '/images/img/service/img_feature-engineering_MeetBellona.png' }, { src: '', youtube: true }],
  }

  const inHouseSupport = [
    {
      text: '生成AIを活用したシステムやサービスの内製化は、企業に大きなメリットをもたらします。例えば、カスタマーサービス用のチャットボットや自動データ分析ツールを内製化することで、コスト削減と迅速な対応が可能です。',
    },
    {
      text: 'さらに、特徴量エンジニアリングを活用すれば、AIモデルの精度を高め、より効果的なシステムを構築できます。まずは自社のニーズを明確にし、適切な生成AIツールを選びましょう。プロトタイプを開発してテストを行い、本格導入することで内製化が実現します。',
    },
    {
      text: '私たちは、生成AIと特徴量エンジニアリングを活用した内製化プロジェクトを支援し、企業のDX（デジタルトランスフォーメーション）を推進します。競争力を高めるために生成AIで内製化を実現しましょう。',
    },
    {
      text: '詳細な情報やご相談は、アイスリーデザインまでお気軽にお問い合わせください。',
    },
  ]

  const leftElement = (
    <div className={styles.left_element}>
      <img src="/images/img/service/img_services_feature_engineering_process.png" alt="" />
    </div>
  )

  return (
    <>
      <ServiceMainTitle serviceMainTitle={serviceMainTitle} paths={paths} />
      <About list={aboutList} />
      <Process list={processList} leftElement={leftElement} sectionSuTitle={'PoCプロジェクトのアプローチ'} />
      <div className={styles.colored}>
        <Whyi3 list={reasonList} titleJa={'主要な特徴'} />
      </div>
      <MeetBellona list={MeetBellonaList} />
      <InHouseSupport subTitle={'デザインスプリントにおける内製化支援'} list={inHouseSupport} />
      <CaseStudy />
      <div className={styles.linklist}>
        <MailmagazineLink />
      </div>
    </>
  )
}

export default FeatureEngineering
